import React from "react";

import { IoMdArrowRoundForward } from "react-icons/io";

const steps = [
  {
    title: "Employee Login",
    desc: "Employees log into the Waggex Staff App using their registered email quickly and securely.",
  },
  {
    title: "GPS Attendance",
    desc: "One tap marks their attendance with live GPS coordinates and a selfie verified instantly.",
  },
  {
    title: "Manager Approval",
    desc: "Leave requests and regularisation approvals happen on the manager's phone no emails needed.",
  },
  {
    title: "Payroll Processing",
    desc: "Attendance data flows into payroll automatically, salary calculated and payslips generated.",
  },
];

const WorkflowSection = () => {
  return (
    <section className="w-full bg-[#F6F9FB] py-10  px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto mt-4 mb-4">
        {/* Heading */}
        <div className="text-center">
          <h2 className="text-[#10324F] text-xl sm:text-3xl font-bold uppercase">
            How It Works
          </h2>

          <p className="mt-4 font-roboto font-normal text-base leading-6 text-center text-[#10324F]">
            Most Indian businesses still rely on WhatsApp check-ins and manual
            registers. Here is how Waggex changes that.
          </p>
        </div>

        {/* Steps */}
        <div className="mt-14 flex flex-col lg:flex-row items-center justify-center gap-5">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              {/* Card */}
              <div
                className="
                  w-full
                  sm:w-65
                  bg-white
                  rounded-2xl
                  p-6
                  transition-all
                  duration-300
                  min-h-38
                  flex flex-col justify-start
                "
                style={{
                  boxShadow: `
      rgb(167 191 210 / 40%) -15px -15px 20px inset,
      rgb(170 188 202 / 30%) -20px -20px 30px
    `,
                }}
              >
                {/* Icon */}
                {/* <div
                  className="
                    w-14 h-14
                    rounded-xl
                    bg-[#f5f8fc]
                    flex items-center justify-center
                    text-[#18395b]
                    shadow-sm
                  "
                >
                  {step.icon}
                </div> */}

                {/* Title */}
                <h2 className="mt-2 text-[#10324F] text-lg font-semibold">
                  {step.title}
                </h2>

                {/* Description */}
                <p className="mt-3 service-list-item-text">{step.desc}</p>
              </div>

              {/* Arrow */}
              {index !== steps.length - 1 && (
                <svg
                  aria-hidden="true"
                  focusable="false"
                  width="30"
                  height="40"
                  viewBox="0 0 52 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="rotate-90 md:rotate-0"
                >
                  <defs>
                    <linearGradient
                      id="arrowGradient"
                      x1="0"
                      y1="0"
                      x2="1"
                      y2="1"
                    >
                      <stop offset="0%" stopColor="#B8C4D1" />
                      <stop offset="100%" stopColor="#6E8194" />
                    </linearGradient>
                  </defs>

                  <path
                    d="M0 10H28V0L52 22L28 44V34H0V10Z"
                    fill="url(#arrowGradient)"
                  />
                </svg>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
